import {
  CalendarIcon,
  SprintIcon,
  StatusIcon,
  TicketsIcon,
  UserIcon,
} from "app/components/Icons";
import TimeIcon from "app/components/Icons/TimeIcon";
import not_started_icon from "assets/Sprints/Frame 1000007476.png";
import active_icon from "assets/Sprints/Frame 1000007477.png";
import completed_icon from "assets/Sprints/Frame 1000007478.png";
import descriptionIcon from "assets/svgs/ic_description.svg";
import progressIcon from "assets/svgs/progress.svg";
import teamIcon from "assets/svgs/team.svg";
import React from "react";
import { TICKET_HEADERS } from "../Boards/data";
import { COLUMN_WIDTHS, SprintStatus } from "./types";
import { differenceInDays, format } from "date-fns";
import { TableHeader } from "app/components/Table/types";
import ContentJson from "app/containers/Features/containers/Sprints/ContentJson.json";


export const getIcon = (type: string) => {
  switch (type) {
    case "status":
      return <StatusIcon size={24} color="#79808A" />;
    case "members":
      return <img src={teamIcon} alt="TicketNameIcon" className=" h-6 w-6 " />;
    case "description":
      return <img src={descriptionIcon} alt="des-icon" className=" h-6 w-6 " />;
    case "scrumMaster":
      return <UserIcon size={24} color="#79808A" />;
    case "sprintName":
      return <SprintIcon size={24} color="#79808A" />;
    case "startEndDates":
      return <CalendarIcon size={24} color="#79808A" />;
    case "ticketsAmount":
      return <TicketsIcon size={24} color="#79808A" />;
    case "velocityTracking":
      return <img src={progressIcon} alt="des-icon" className=" h-6 w-6 " />;
    case "capacityHours":
      return <TimeIcon size={24} color="#79808A" />;
    default:
      return <SprintIcon size={24} color="#79808A" />;
  }
};

export const getSprintStatusIcon = (type: SprintStatus) => {
  switch (type) {
    case SprintStatus.ACTIVE:
      return active_icon;
    case SprintStatus.NOT_STARTED:
      return not_started_icon;
    case SprintStatus.COMPLETED:
      return completed_icon;

    default:
      return active_icon;
  }
};

const getHeaderWidth = (type: string): number => {
  return COLUMN_WIDTHS[type] ?? 200;
};

export function getUpdatedColumns(data: any[]) {
  return data
    ?.filter((field) => {
      return  field.isVisible;
    })
    ?.sort((a, b) => a.order - b.order)
    .map((field) => {
      const existingColumn = TICKET_HEADERS.find(
        (col) => col.name === field.fieldName
      );

      return (
        existingColumn || {
          name: field.fieldName,
          id: field.type,
          sortable: true,
          className: "!p-[4px] text-xs leading-[18px] font-medium",
          width: getHeaderWidth(field.type),
        }
      );
    });
}

export const statusOptions = [
  { label: "Active", value: SprintStatus.ACTIVE },
  {
    label: "Not started",
    value: SprintStatus.NOT_STARTED,
  },
  { label: "Completed", value: SprintStatus.COMPLETED },
];

export const fixedDateOptions = [
  { key: "thisMonth", label: "This month" },
  { key: "lastMonth", label: "Last month" },
  { key: "last6Months", label: "Last 6 months" },
  { key: "thisQuarter", label: "This quarter" },
  { key: "lastQuarter", label: "Last quarter" },
  { key: "thisYear", label: "This year" },
  { key: "lastYear", label: "Last year" },
];
export const getSafeFormattedDate = (
  dateStr?: Date | string,
  formatStr = "dd MMM, yyyy"
): string => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return isNaN(date.getTime()) ? "" : format(date, formatStr);
};

export const getWeekDifference = (
  startDate: string,
  endDate: string
): string => {
  if (!startDate || !endDate) return "";

  const diffDays = differenceInDays(new Date(endDate), new Date(startDate));
  const weeks = Math.floor(diffDays / 7);

  return `${weeks} week${weeks !== 1 ? "s" : ""}`;
};
const { creator, pointName, votedMembers, votes } = ContentJson.retrospective;
export const retrospectivePointsHeaders: TableHeader[] = [
  {
    name: pointName,
    id: "name",
    align: "left",
  },
  {
    name: creator,
    id: "creator",
    align: "left",
  },
  {
    name: votes,
    id: "votes",
    align: "left",
  },
  {
    name: votedMembers,
    id: "votedMembers",
    align: "left",
  },
];
const { members, dayOff, dailyCapacity } = ContentJson.capacity;
export const capacityHeaders: TableHeader[] = [
  {
    name: members,
    id: "members",
    align: "left",
  },
  {
    name: dayOff,
    id: "daysOff",
    align: "left",
  },
  {
    name: dailyCapacity,
    id: "dailyCapacity",
    align: "left",
  },
];
const { name:unResolvedTicketName, status:unResolvedTicketStatus } = ContentJson;
export const unResolvedTicketHeaders: TableHeader[] = [
  {
    name: unResolvedTicketName,
    id: "name",
    align: "left",
  },
  {
    name: unResolvedTicketStatus,
    id: "status",
    align: "left",
  },
];

export const dailyCapacityOptions = [
  { label: "5.0", value: "5.0" },
  { label: "5.5", value: "5.5" },
  { label: "6.0", value: "6.0" },
  { label: "6.5", value: "6.5" },
  { label: "7.0", value: "7.0" },
  { label: "7.5", value: "7.5" },
  { label: "8.0", value: "8.0" },
  { label: "8.5", value: "8.5" },
  { label: "9.0", value: "9.0" },
  { label: "9.5", value: "9.5" },
  { label: "10.0", value: "10.0" },
  { label: "10.5", value: "10.5" },
  { label: "11.0", value: "11.0" },
  { label: "11.5", value: "11.5" },
  { label: "12.0", value: "12.0" },
];

const { name, status, assignee, est, sprint } = ContentJson.ticket;
export const existingTicketListHeaders: TableHeader[] = [
  {
    name: name,
    id: "name",
    align: "left",
  },
  {
    name: status,
    id: "status",
    align: "left",
  },
  {
    name: assignee,
    id: "assignee",
    align: "left",
  },
  {
    name: est,
    id: "est",
    align: "left",
  },
  {
    name: sprint,
    id: "sprint",
    align: "left",
  },
];
export const ticketListHeaders: TableHeader[] = [
  {
    name: name,
    id: "name",
    align: "left",
  },
  {
    name: status,
    id: "status",
    align: "left",
  },
  {
    name: assignee,
    id: "assignee",
    align: "left",
  },
  {
    name: est,
    id: "est",
    align: "left",
  },
];




const statusOrder = ['Open', 'In Progress', 'Blocked', 'Closed']
const priorityOrder = ['Low', 'Medium', 'High', 'Urgent']

function valueForField(item, fieldKey) {
  switch (fieldKey) {
    case 'ticketName': return item.ticketName ?? ''
    case 'status': return item.status ?? ''
    case 'dueDate': return item.dueDate ?? ''
    case 'priority': return item.priority ?? ''
    default: return ''
  }
}

function compare(a, b, fieldKey, order) {
  const dir = order === 'desc' ? -1 : 1
  let av = valueForField(a, fieldKey)
  let bv = valueForField(b, fieldKey)

  if (fieldKey === 'status') {
    av = statusOrder.indexOf(av)
    bv = statusOrder.indexOf(bv)
    return (av - bv) * dir
  }
  if (fieldKey === 'priority') {
    av = priorityOrder.indexOf(av)
    bv = priorityOrder.indexOf(bv)
    return (av - bv) * dir
  }
  if (fieldKey === 'dueDate') {
    av = new Date(av).getTime()
    bv = new Date(bv).getTime()
    return (av - bv) * dir
  }
  // String compare (ticketName)
  return (String(av).localeCompare(String(bv))) * dir
}

/** Multi-rule sorting; rules earlier have higher priority */
export function applySort(items, rules) {
  const validRules = rules.filter(r => r.fieldKey)
  return [...items].sort((a, b) => {
    for (const r of validRules) {
      const res = compare(a, b, r.fieldKey, r.order)
      if (res !== 0) return res
    }
    return 0
  })
}
export const sprintTicketShortFields = [
  { key: "ticketName", label: "Ticket Name", icon: "ticket" },
  { key: "status", label: "Status", icon: "status" },
  { key: "assigneeName", label: "Assignee Name", icon: "assignee" },
];